import axios from "axios";
import join from "url-join";
import { STORAGE } from "../constants";

const isAbsoluteURLRegex = /^(?:\w+:)\/\//;

axios.interceptors.request.use(async (config) => {
  if (!isAbsoluteURLRegex.test(config.url)) {
    config.url = join(process.env.REACT_APP_API_BASE_URL, config.url);
  }

  const authData = localStorage.getItem(STORAGE.PREFIX + STORAGE.AUTH_KEY);
  const parsedAuthData = authData ? JSON.parse(authData) : null;
  
  if (parsedAuthData && parsedAuthData.authToken) {
    localStorage.removeItem(STORAGE.AUTH_KEY);
  }

  const authToken =
    parsedAuthData && parsedAuthData.authToken
      ? JSON.parse(parsedAuthData.authToken)
      : localStorage.auth
      ? JSON.parse(localStorage.auth)
      : undefined;

  if (authToken) {
    config.headers = { Authorization: `Bearer ${authToken}` };
  }

  config.timeout = 90000; // 90 seconds timeout
  return config;
});

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // Handle specific error responses, if necessary
    return Promise.reject(error);
  }
);

export const httpClient = axios;

export const getQueryParams = (t) => {
  if (!t || typeof t !== "string" || t.length < 2) return new Map();
  const r = t
    .substr(1)
    .split("&")
    .map((t) => {
      const r = t.split("=");
      return [r[0], r[1]];
    });
  return new Map(r);
};

export const generateQueryParams = (t) => {
  if (!t || typeof t !== "object") return "";
  let query = "";
  for (const [key, value] of Object.entries(t)) {
    query += `${key}=${value}&`;
  }
  return query;
};
